module.exports = __webpack_public_path__ + "img/find-online-empty.ea02998f.svg";